import { Translate, trans } from '@lingoda/i18n';
import { StepComponent } from './StepComponent';

export const Step1 = () => (
    <StepComponent title={trans('product-tour-step1-title', {}, 'student-common')}>
        <Translate id="product-tour-step1-description" domain="student-common" component="div" />
    </StepComponent>
);
